import { LOGIN, LOGOUT, LOGIN_ERROR } from "store/actions/authAction";

const initState = {
  httpStatus: 0,
  payload: {},
  errors: []
};
function login(state = initState, action) {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        httpStatus: action.httpStatus,
        isAuthenticated: action.httpStatus === 200 ? true : false,
        payload: action.payload
      };
    case LOGIN_ERROR:
      return {
        ...state,
        httpStatus: action.httpStatus,
        isAuthenticated: action.httpStatus,
        payload: action.payload
      };
    case LOGOUT:
      return {
        ...state,
        httpStatus: action.httpStatus,
        isAuthenticated: false,
        payload: action.payload
      };
    default:
      return state;
  }
}

export default login;
